import * as React from 'react';
import type { SVGProps } from 'react';

const SvgNh = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="m836.4 924-21.602-26.398 1.2-31.199v-1.2l-42-52.8-10.798-332.4-20.398-328.8c0-1.2 0-1.2-1.199-1.2h-2.398l-14.398 7.2-52.805 4.8s-1.2 0-1.2 1.2l-18 18v1.199l-27.602 72v1.2l7.2 26.397-32.398 51.605v2.399l22.8 55.199-9.601 25.199-64.801 60-45.602 14.398c-1.2 0-1.2 1.199-1.2 1.199l-18 120-76.8 150v1.199l-19.2 189.6-24 50.398v2.398l24 46.801c0 1.2 1.2 1.2 2.4 1.2h304.798L792 996l25.2 3.601c1.199 0 2.398 0 2.398-1.199l18-72c.004-1.203-1.2-2.402-1.2-2.402z" />
  </svg>
);
export default SvgNh;
